import { PageHeader } from "@/components/site/shared";
import { EMAIL, PHONE } from "@/lib/config";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      ["Overview", "Veterans Power Wash & Cleaning Services respects your privacy. This policy explains what information we collect and how we use it."],
      ["Information We Collect", "We collect information you provide through quote requests, contact forms, and our Ghost AI assistant, such as your name, phone number, email, property address, and project details, along with any photos you choose to upload."],
      ["How We Use Your Information", "We use your information solely to respond to your request, provide quotes and services, and communicate with you about your project."],
      ["Financing Referrals", "If you choose to explore financing, we may refer you to EasyQuickFund, an independent third-party financing provider. We only share the minimum information needed to create a referral, and only with your consent. Approval and terms are determined by the financing provider."],
      ["Photo Uploads", "Photos you submit with a quote request are kept private and are not published publicly without your permission."],
      ["Communications", "By providing your phone number, you consent to receive calls and text messages regarding your request. Message and data rates may apply. You may opt out at any time."],
      ["Contact", `Questions about this policy? Email ${EMAIL} or call ${PHONE}.`],
    ],
  },
  terms: {
    title: "Terms of Use",
    body: [
      ["Acceptance", "By using this website you agree to these terms."],
      ["Services", "Information on this website is provided for general purposes. Quotes are estimates and are subject to confirmation. No binding estimate or guarantee is made through this website."],
      ["Financing", "Financing options may be available through EasyQuickFund. Financing is subject to application, approval, and the provider's terms. Veterans Power Wash & Cleaning Services does not provide financing directly."],
      ["Intellectual Property", "All content, logos, and images are the property of Veterans Power Wash & Cleaning Services or their respective owners."],
      ["Limitation of Liability", "This website is provided \"as is\" without warranties of any kind."],
      ["Contact", `Questions? Email ${EMAIL} or call ${PHONE}.`],
    ],
  },
  accessibility: {
    title: "Accessibility Statement",
    body: [
      ["Our Commitment", "Veterans Power Wash & Cleaning Services is committed to making our website accessible to everyone, including people with disabilities."],
      ["Standards", "We strive to follow WCAG accessibility guidelines, including sufficient color contrast, keyboard navigation, and descriptive text alternatives for images."],
      ["Feedback", `If you encounter any accessibility barriers, please contact us at ${EMAIL} or ${PHONE} so we can help and improve.`],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  return (
    <div>
      <PageHeader overline="Legal" title={c.title} />
      <section className="section-pad">
        <div className="max-w-3xl mx-auto px-4 space-y-8">
          {c.body.map(([h, p]) => (
            <div key={h}>
              <h2 className="font-head font-bold text-xl text-[var(--navy)] uppercase">{h}</h2>
              <p className="text-[var(--text-muted)] mt-2 leading-relaxed">{p}</p>
            </div>
          ))}
          <p className="text-xs text-gray-400">Last updated: {new Date().toLocaleDateString()}. This content is a starting point and should be reviewed before final publication.</p>
        </div>
      </section>
    </div>
  );
}
